export default __webpack_public_path__ + "static/media/write-begin.f87553cf.wav";